import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StockPurchaseOrderApprovals, StockPurchaseOrderApprovalsWithUser } from '~/models/administration/stockPurchaseOrderApprovals';
import { POApprovalsService } from '~/services/administration.ts/po-approvals';
import { UsersService } from '~/services/administration.ts/users';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { ThemeManagerService } from '~/services/theme-manager';
import { ComboBoxComponent, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { SharedService } from '~/services/sharedService';
import { PageState } from '~/shared/enums/stock-files.enum';
import { StockPurchaseOrderApprovalResponseModel } from '~/models/administration/stockPurchaseOrderApprovalResponseModel';
import { AccountsService } from '~/services/administration.ts/accounts';
import { SiteLisitng } from '~/models/administration/site';
import { VendorListing } from '~/models/modules/vendor';
import { PoApprovalCycleRequestModel } from '~/models/administration/poApprovalCycleRequestModel';
import { ApprovalDetailsRequestModel } from '~/models/administration/approvalDetailsRequestModel';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { firstValueFrom, interval, Subscription } from 'rxjs';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { Notification } from '~/shared/enums/notification.enum';

@Component({
    selector: 'po-approval-cycle.component-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StockAdminPOApprovalsUpsertComponent implements OnInit {
  @ViewChild('person1ComboBox') person1ComboBox: MultiSelectComponent;
  @ViewChild('cycleCode') inputCycleCode: ElementRef;
  @ViewChild('kendo_multiselect') kendoMultiselect: MultiSelectComponent;
  @ViewChild('statusComboBox') statusComboBox: ComboBoxComponent;
  @ViewChild('nextButton') nextButton: ElementRef;
  @ViewChild('notificationComboBox') notificationComboBox: ComboBoxComponent;
  @ViewChild('creatorPendingNotification') creatorPendingNotification: ComboBoxComponent;
  @ViewChild('creatorApproveNotification') creatorApproveNotification: ComboBoxComponent;
  @ViewChild('creatorRejectNotification') creatorRejectNotification: ComboBoxComponent;
  @ViewChild('numberOfApproverComboBox') numberOfApproverComboBox: ComboBoxComponent;
  @ViewChild('firstApproverComboBox') firstApproverComboBox: ComboBoxComponent;
  @ViewChild('firstApproverApprovedComboBox') firstApproverApprovedComboBox: ComboBoxComponent;
  @ViewChild('firstApproverRejectComboBox') firstApproverRejectComboBox: ComboBoxComponent;
  @ViewChild('secondApproverComboBox') secondApproverComboBox: ComboBoxComponent;
  @ViewChild('person2ComboBox') person2ComboBox: ComboBoxComponent;
  @ViewChild('secondApproverApprovedComboBox') secondApproverApprovedComboBox: ComboBoxComponent;
  @ViewChild('secondApproverRejectComboBox') secondApproverRejectComboBox: ComboBoxComponent;

  notificationSubscription: Subscription;
  numberOfApproverSubscription: Subscription;

  value = 100;
  progressStyles = { color: '#74D095', background: '#74D095' }
  emptyStyles = { color: 'black', background: 'white' }

  _theme: string;
  _isNew: boolean;
  _active: boolean;
  _selectedPerson1Item = new FormControl();
  _selectedPerson2Item = new FormControl();
  _selectedCycle = new FormControl();
  _codeFormControl = new FormControl();
  _currentStep = 0;
  _currentNotificationOption: string;
  _notificationOptionValue: string;
  _approverNumberValue: number;
  _currentApproverNumber: number;
  popupVisible = false;

  _isPendingPurchaseOrder: boolean = false;
  _pendingPurchaseOrderNumbers: string;
  _pendingPurchaseOrderLength: number;
  _approvalStatus = [
    {
      name: 'Enable',
      value: true
    },
    {
      name: 'Disable',
      value: false
    }
  ];


  firstApprover: any;
  sndApprover: any;
  selectedPerson1Item: any;
  selectedPerson2Item: any;


  _firstApprover = [
    {
      field: 'isCreatorManager1',
      displayName: 'Creator\'s Manager',
    },
    {
      field: 'isPerson1',
      displayName: 'Choose a person',
    },
    {
      field: 'isAdminSecurityLevel1',
      displayName: 'Any Admin Level Person',
    }
  ];
  _sndApprover = [
    {
      field: 'isCreatorManager2',
      displayName: 'Creator\'s Manager',
    },
    {
      field: 'isPerson2',
      displayName: 'Choose a person',
    },
    {
      field: 'isAdminSecurityLevel2',
      displayName: 'Any Admin Level Person',
    }
  ];
  _booleanData = [
    'Yes',
    'No'
  ];
  _pendingNotification = [
    'None',
    'Email'
  ]
  _notification = [
    'None',
    'Email',
    'CC'
  ];
  _approverNumberData = [
    1,
    2
  ];
  // _form: FormGroup;
  _stockPurchaseOrderApprovalsWithUsers: StockPurchaseOrderApprovalsWithUser;
  _selectedStockPurchaseOrderApproval: StockPurchaseOrderApprovals;
  showApprovalCycleTextField = false;
  userSites: any = [];

  public _selectedVendors: any[] = [];
  public persons: any[] = [];
  public gridSelection: string[] = [];
  private selectedCycleId: number;
  personsFiltered1: any[];
  personsFiltered2: any[];

  _currentForm: FormGroup;
  _form: FormGroup;

  _steps = [
    { label: 'Approval Cycle Info' },
    { label: 'Assign Vendors', disabled: true },
    { label: 'PO Creator', disabled: true },
    { label: 'Approver(s)', disabled: true }
  ];

  _invalidForm: boolean;
  emailCcObjsList: any = {
    person1Id: 0,
    approval1Creator_Email: false,
    isCreatorManager1IsChecked: false,
    isPerson1IsChecked: false,
    isAdminSecurityLevel1IsChecked: false,
    approval1Manager_EmailIsCheckedIsChecked: false,
    approval1Manager_CcIsChecked: false,
    approval1PersonId_EmailIsChecked: false,
    approval1PersonId_CcIsChecked: false,
    approval1AdminSecurityLevelPerson_EmailIsChecked: false,
    approval1AdminSecurityLevelPerson_CcIsChecked: false,
    approval1ApproverRejectsCreator_EmailIsChecked: false,
    approval1ApproverRejectsCreator_CcIsChecked: false,
    approval1Approver1RejectsApprover1_EmailIsChecked: false,
    approval1Approver1RejectsApprover1_CcIsChecked: false,
    approval1Approver1ApprovesCreator_EmailIsChecked: false,
    approval1Approver1ApprovesCreator_CcIsChecked: false,
    approval1Approver1ApprovesApprover1_EmailIsChecked: false,
    approval1Approver1ApprovesApprover1_CcIsChecked: false,

    person2Id: 0,
    isCreatorManager2IsChecked: false,
    isPerson2IsChecked: false,
    isAdminSecurityLevel2IsChecked: false,
    approval2Manager_EmailIsChecked: false,
    approval2Manager_CcIsChecked: false,
    approval2PersonId_EmailIsChecked: false,
    approval2PersonId_CcIsChecked: false,
    approval2AdminSecurityLevel_EmailIsChecked: false,
    approval2AdminSecurityLevel_CcIsChecked: false,
    approval2RejectsCreator_EmailIsChecked: false,
    approval2RejectsCreator_CcIsChecked: false,
    approval2RejectsApprover1_EmailIsChecked: false,
    approval2RejectsApprover1_CcIsChecked: false,
    approval2RejectsApprover2_EmailIsChecked: false,
    approval2RejectsApprover2_CcIsChecked: false,
    approval2ApprovesCreator_EmailIsChecked: false,
    approval2ApprovesCreator_CcIsChecked: false,
    approval2ApprovesApprover1_EmailIsChecked: false,
    approval2ApprovesApprover1_CcIsChecked: false,
    approval2ApprovesApprover2_EmailIsChecked: false,
    approval2ApprovesApprover2_CcIsChecked: false,
  };


  _pageState: PageState;
  _model: any;
  stockPurchaseOrderApprovalResponse: StockPurchaseOrderApprovalResponseModel;
  isEditMode: boolean = false;
  //sites: SiteLisitng[];
  sites: any[] = [];
  //selectedSites: SiteLisitng[];
  selectedSites: any[] = [];
  selectedSiteIds: number[] = [];
  vendors: VendorListing[];
  statusValue: any = {
    name: 'Enable',
    value: true
  };
  isEnable: boolean = true;
  approvalCycleCode: string;
  selectedVendors: VendorListing[] = [];

  creatorEmail: string;
  approvesCreator: string;
  rejectsCreator: string;

  creator_Email: boolean = false;
  approverApprovesCreator_Email: boolean = false;
  approverApprovesCreator_Cc: boolean = false;
  approverRejectsCreator_Email: boolean = false;
  approverRejectsCreator_Cc: boolean = false;


  poApprovalCycleRequest: PoApprovalCycleRequestModel;

  approval1Approver1ApprovesApprover1: any;
  approval1Approver1RejectsApprover1: any;
  approval2ApprovesApprover2: any;
  approval2RejectsApprover1: any;
  loggedInSite: any;

  constructor(
    private _usersService: UsersService,
    private _layoutComponent: LayoutComponent,
    private _themeManager: ThemeManagerService,
    private _poApprovalsService: POApprovalsService,
    private _vendorsService: VendorsService,
    private _layoutManager: LayoutManagerService,
    private formBuilder: FormBuilder,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _sharedService: SharedService,
    private _multiSitesService: MultiSiteService) {
    this._form = this.formBuilder.group({
      _selectedCycle: new FormControl(null, Validators.required),
      notificationOption: [],
      approverNumber: [],
      firstApprover: [],
      approval1Approver1ApprovesApprover1: [],
      approval1Approver1RejectsApprover1: [],
      approval2RejectsApprover1: [],
      approval1ApproverRejectsCreator: [],
      approval1AdminSecurityLevelPerson: [],
      approval1Approver1ApprovesCreator: [],
      approval2Manager: [],
      approval2AdminSecurityLevel: [],
      approval2ApprovesCreator: [],
      approval2ApprovesApprover1: [],
      approval2RejectsApprover2: [],
      approval2RejectsCreator: [],
      approval1Manager: [],
      sndApprover: [],
      code: [],
      enableCycle: [this.enableCycle()],
      enableApproval1: [],
      approval1Creator_Email: [],
      approval1PersonId: [],
      approval1PersonId_Email: [],
      approval1PersonId_Cc: [],
      enableApproval2: [],
      approval2PersonId: [],
      approval2PersonId_Email: [],
      approval2PersonId_Cc: [],
      siteNames: [],
      selectedCustSupp: [],
      createdUnderSite: [],
      status: [],
    });

    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();
    // this._initPage(true);
    this._form.valueChanges.subscribe((x) => {
      this._currentForm = this.getFormByStep(this._currentStep);
      this.validateSteps();
    });
  }

  ngOnInit() {
    this._initPage(true);
    this.SetNotificationIntervalListener();
    this.SetNumberOfApproverIntervalListener();
    if (this._isPendingPurchaseOrder && this._pendingPurchaseOrderLength > 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Cannot update approval cycle that is related to pending purchase orders ( ' + this._pendingPurchaseOrderLength + ' Pending Purchase Orders)',
        withoutConfirm: true
      });
    }

  }


  SetNotificationIntervalListener() {
    var source = interval(500);
    this.notificationSubscription = source.subscribe(val => {
      if (this.notificationComboBox && this.notificationComboBox.isOpen == false) {
        // this.notificationComboBox.isFocused = true;
        this.notificationComboBox.toggle(true);
        this.notificationSubscription.unsubscribe();
      }
    }
    );
  }



  SetNumberOfApproverIntervalListener() {
    var source = interval(500);
    this.numberOfApproverSubscription = source.subscribe(val => {
      if (this.numberOfApproverComboBox && this.numberOfApproverComboBox.isOpen == false) {
        // this.numberOfApproverComboBox.isFocused = true;
        this.numberOfApproverComboBox.toggle(true);
        this.numberOfApproverSubscription.unsubscribe();
      }
    }
    );
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._isPendingPurchaseOrder = this._model.hasPendingPurchaseOrders;
    this._pendingPurchaseOrderNumbers = this._model.pendingPurchaseOrderNumbers;
    this._pendingPurchaseOrderLength = this._model.pendingPurchaseOrderNumbers?.length;
    this.isEditMode = this._sharedService.model && this._sharedService.model.model && this._sharedService.model.model.id ? true : false;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
  }



  private validateSteps() {
    this._steps.forEach((x, index) => {
      x['disabled'] = !this._canGoToStep(index);
      this._currentForm = this.getFormByStep(this._currentStep);
    });
  }

  previousStep() {
    if (this._currentStep > 0) {
      this._currentStep -= 1;

      if (!this.notificationSubscription || this.notificationSubscription.closed == true) {
        this.SetNotificationIntervalListener();
      }
      if (!this.numberOfApproverSubscription || this.numberOfApproverSubscription.closed == true) {
        this.SetNumberOfApproverIntervalListener();
      }
    }
  }

  nextStep() {
    if (!this._steps[this._currentStep + 1]['disabled']) {
      if (this._currentStep < this._steps.length - 1) {
        this._currentStep += 1;
      }
      this._invalidForm = false;
    } else {
      this._currentForm = this.getFormByStep(this._currentStep);
      if (this._currentForm && this._canGoToStep(this._currentStep + 1)) {
        this._currentStep += 1;
      }
      this._invalidForm = true;
    }
  }


  NavigateToTheNextStep() {
    if (this._isPendingPurchaseOrder) {
      if (this._currentStep < this._steps.length - 1) {
        this._currentStep += 1;
        this._steps[this._currentStep]['disabled'] = false;
        return;
      }
    }
    if (this._currentStep == 0) {
      if (this.approvalCycleCode &&
        this.approvalCycleCode.length > 0 &&
        this.selectedSiteIds &&
        this.selectedSiteIds.length > 0 &&
        this.isEnable != undefined) {
        if (this._currentStep < this._steps.length - 1) {
          this._currentStep += 1;
          this._steps[this._currentStep]['disabled'] = false;
          return;
        }
      }
    }
    if (this._currentStep == 1) {
      if (this.selectedVendors && this.selectedVendors.length > 0) {
        if (this._currentStep < this._steps.length - 1) {
          this._currentStep += 1;
          this._steps[this._currentStep]['disabled'] = false;
          return;
        }
      }
    }
    if (this._currentStep == 2) {
      if (this._notificationOptionValue && (this._notificationOptionValue.toLowerCase() == 'yes' || this._notificationOptionValue.toLowerCase() == 'no')) {
        if (this._currentStep < this._steps.length - 1) {
          this._currentStep += 1;
          this._steps[this._currentStep]['disabled'] = false;
          return;
        }
      }
    }
  }

  async PendingRequestNotification(event: any) {
    this.creatorEmail = event;
    if (event && event.toLowerCase() == 'email') {
      this.creator_Email = true;
    }
    else {
      this.creator_Email = false;
    }

    await this.delay(300);

    if (this.creatorApproveNotification) {
      // this.creatorApproveNotification.isFocused = true;
      this.creatorApproveNotification.toggle(true);
    }

  }


  async ApprovedRequestNotification(event: any) {
    this.approvesCreator = event;
    if (event && event.toLowerCase() == 'email') {
      this.approverApprovesCreator_Email = true;
      this.approverApprovesCreator_Cc = false;
    }
    else if (event && event.toLowerCase() == 'cc') {
      this.approverApprovesCreator_Email = false;
      this.approverApprovesCreator_Cc = true;
    }
    else {
      this.approverApprovesCreator_Email = false;
      this.approverApprovesCreator_Cc = false;
    }

    await this.delay(300);
    if (this.creatorRejectNotification) {
      // this.creatorRejectNotification.isFocused = true;
      this.creatorRejectNotification.toggle(true);
    }

  }


  RejectedRequestNotification(event: any) {
    this.rejectsCreator = event;
    if (event && event.toLowerCase() == 'email') {
      this.approverRejectsCreator_Email = true;
      this.approverRejectsCreator_Cc = false;
    }
    else if (event && event.toLowerCase() == 'cc') {
      this.approverRejectsCreator_Email = false;
      this.approverRejectsCreator_Cc = true;
    }
    else {
      this.approverRejectsCreator_Email = false;
      this.approverRejectsCreator_Cc = false;
    }
  }



  async PickApprover(event: any) {
    if (event && event.field == 'isCreatorManager1') {
      this.firstApprover = event;
      this.emailCcObjsList.isCreatorManager1IsChecked = true;
      this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked = true;
      this.emailCcObjsList.approval1Manager_CcIsChecked = false;
      this.emailCcObjsList.isPerson1IsChecked = false;
      this.emailCcObjsList.approval1PersonId_EmailIsChecked = false;
      this.emailCcObjsList.approval1PersonId_CcIsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel1IsChecked = false;
      this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked = false;
      this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked = false;

      if (this.firstApproverApprovedComboBox) {
        // this.firstApproverApprovedComboBox.isFocused = true;
        this.firstApproverApprovedComboBox.toggle(true);
      }

    }
    else if (event && event.field == 'isPerson1') {
      this.firstApprover = event;
      this.emailCcObjsList.isCreatorManager1IsChecked = false;
      this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked = false;
      this.emailCcObjsList.approval1Manager_CcIsChecked = false;
      this.emailCcObjsList.isPerson1IsChecked = true;
      this.emailCcObjsList.approval1PersonId_EmailIsChecked = true;
      this.emailCcObjsList.approval1PersonId_CcIsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel1IsChecked = false;
      this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked = false;
      this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked = false;

      await this.delay(500)

      if (this.person1ComboBox) {
        // this.person1ComboBox.isFocused = true;
        this.person1ComboBox.toggle(true);
      }
    }
    else if (event && event.field == 'isAdminSecurityLevel1') {
      this.firstApprover = event;
      this.emailCcObjsList.isCreatorManager1IsChecked = false;
      this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked = false;
      this.emailCcObjsList.approval1Manager_CcIsChecked = false;
      this.emailCcObjsList.isPerson1IsChecked = false;
      this.emailCcObjsList.approval1PersonId_EmailIsChecked = false;
      this.emailCcObjsList.approval1PersonId_CcIsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel1IsChecked = true;
      this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked = true;
      this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked = false;

      if (this.firstApproverApprovedComboBox) {
        // this.firstApproverApprovedComboBox.isFocused = true;
        this.firstApproverApprovedComboBox.toggle(true);
      }
    }
    else if (event && event.field == 'isCreatorManager2') {
      this.sndApprover = event;
      this.emailCcObjsList.isCreatorManager2IsChecked = true;
      this.emailCcObjsList.approval2Manager_EmailIsChecked = true;
      this.emailCcObjsList.approval2Manager_CcIsChecked = false;
      this.emailCcObjsList.isPerson2IsChecked = false;
      this.emailCcObjsList.approval2PersonId_EmailIsChecked = false;
      this.emailCcObjsList.approval2PersonId_CcIsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel2IsChecked = false;
      this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked = false;
      this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked = false;


      if (this.secondApproverApprovedComboBox) {
        // this.secondApproverApprovedComboBox.isFocused = true;
        this.secondApproverApprovedComboBox.toggle(true);
      }
    }
    else if (event && event.field == 'isPerson2') {
      this.sndApprover = event;
      this.emailCcObjsList.isCreatorManager2IsChecked = false;
      this.emailCcObjsList.approval2Manager_EmailIsChecked = false;
      this.emailCcObjsList.approval2Manager_CcIsChecked = false;
      this.emailCcObjsList.isPerson2IsChecked = true;
      this.emailCcObjsList.approval2PersonId_EmailIsChecked = true;
      this.emailCcObjsList.approval2PersonId_CcIsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel2IsChecked = false;
      this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked = false;
      this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked = false;


      await this.delay(500)
      if (this.person2ComboBox) {
        // this.person2ComboBox.isFocused = true;
        this.person2ComboBox.toggle(true);
      }
    }
    else if (event && event.field == 'isAdminSecurityLevel2') {
      this.sndApprover = event;
      this.emailCcObjsList.isCreatorManager2IsChecked = false;
      this.emailCcObjsList.approval2Manager_EmailIsChecked = false;
      this.emailCcObjsList.approval2Manager_CcIsChecked = false;
      this.emailCcObjsList.isPerson2IsChecked = false;
      this.emailCcObjsList.approval2PersonId_EmailIsChecked = false;
      this.emailCcObjsList.approval2PersonId_CcIsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel2IsChecked = true;
      this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked = true;
      this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked = false;


      if (this.secondApproverApprovedComboBox) {
        // this.secondApproverApprovedComboBox.isFocused = true;
        this.secondApproverApprovedComboBox.toggle(true);
      }
    }
    else if (!event) {
      this.firstApprover = undefined;
      this.sndApprover = undefined;
      this.emailCcObjsList.isCreatorManager1IsChecked = false;
      this.emailCcObjsList.isPerson1IsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel1IsChecked = false;
      this.emailCcObjsList.isCreatorManager2IsChecked = false;
      this.emailCcObjsList.isPerson2IsChecked = false;
      this.emailCcObjsList.isAdminSecurityLevel2IsChecked = false;
    }
  }


  GetSelectedVendor(event: any) {
    this.selectedVendors = [];
    this.selectedVendors = event;

  }

  private getFormByStep(step: number) {
    switch (step) {
      case 0:
        return this.formBuilder.group({
          _selectedCycle: new FormControl(this._form.get('_selectedCycle').value, Validators.required),
        });
      case 1:
        return this.formBuilder.group({
          _selectedCycle: new FormControl(this._form.get('_selectedCycle').value, Validators.required),
        });
    }
  }

  _canGoToStep(step: number) {
    switch (step) {
      case 0:
        return true;
      case 1:
        if (this._form.get('_selectedCycle').value) {
          return true;
        } else {
          return false;
        }
      case 2:
        return true;
      case 3:
        return true;
      case 4:
        return true;
    }
  }

  _onSave(e: any) {
    this.submit();
  }
  _closeForm() {
    var closeComponent = {
      component: 'poApprovals',
      isClosed: true
    }

    this._active = false;
    this.ngOnDestroy();

    this._sharedService.closeDialog.emit(closeComponent);
    this._gridLayoutManagerService.setGridDataSubjects('poApprovals');
    this._sharedService.model = {};
  }
  _onUploadClick() {

  }

  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  deselectIfAlreadySelected(names: string[], name: string) {
    let shouldProceed = true;
    for (let i = 0; i < names.length; i++) {
      const n = names[i];
      if (this.emailCcObjsList[n + 'IsChecked']) {
        this._form.controls[n].setValue(false);
        this.emailCcObjsList[n + 'IsChecked'] = false;
        if (n === name) {
          shouldProceed = false;
        }
      }
    }
    if (shouldProceed) {
      this._form.controls[name].setValue(!this._form.controls[name].value);
      this.emailCcObjsList[name + 'IsChecked'] = !this.emailCcObjsList[name + 'IsChecked'];
    }
  }

  handlePersonItemsFilter(value: any, index: number) {
    if (index === 1) {
      this.personsFiltered1 = this.persons.filter(
        (s) => s.firstName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
          s.lastName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
          s.code?.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }
    else if (index === 2) {
      this.personsFiltered2 = this.persons.filter(
        (s) => s.firstName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
          s.lastName?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
          s.code?.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

  }

  clearValues(names: string[]) {
    for (let i = 0; i < names.length; i++) {
      const n = names[i];
      this._form.controls[n].setValue(false);
      this.emailCcObjsList[n + 'IsChecked'] = false;
    }
  }

  onPersonsGridSelectionChange(event: any, idx: number) {
    if (event) {
      if (idx === 1) {
        this._form.controls['approval1PersonId'].setValue(event.id);
        this.emailCcObjsList.person1Id = event.id;

        if (this.firstApproverApprovedComboBox) {
          // this.firstApproverApprovedComboBox.isFocused = true;
          this.firstApproverApprovedComboBox.toggle(true);
        }
      }
      else if (idx === 2) {
        this._form.controls['approval2PersonId'].setValue(event.id);
        this.emailCcObjsList.person2Id = event.id;

        if (this.secondApproverApprovedComboBox) {
          // this.secondApproverApprovedComboBox.isFocused = true;
          this.secondApproverApprovedComboBox.toggle(true);
        }

      }
    }
    else if (!event) {
      this.emailCcObjsList.person1Id = 0;
      this.emailCcObjsList.person2Id = 0;
    }
  }


  ApproverConfiguration(event: any, key: string, idx: number) {
    if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'approved' && idx == 1) {
      this.approval1Approver1ApprovesApprover1 = event;
      this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = true;
      this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;

      if (this.firstApproverRejectComboBox) {
        // this.firstApproverRejectComboBox.isFocused = true;
        this.firstApproverRejectComboBox.toggle(true);
      }
    }
    else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'approved' && idx == 1) {
      this.approval1Approver1ApprovesApprover1 = event;
      this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = false;
      this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = true;

      if (this.firstApproverRejectComboBox) {
        // this.firstApproverRejectComboBox.isFocused = true;
        this.firstApproverRejectComboBox.toggle(true);
      }
    }
    else if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'rejected' && idx == 1) {
      this.approval1Approver1RejectsApprover1 = event;
      this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = true;
      this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false;

      if (this.secondApproverComboBox) {
        // this.secondApproverComboBox.isFocused = true;
        this.secondApproverComboBox.toggle(true);
      }
    }
    else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'rejected' && idx == 1) {
      this.approval1Approver1RejectsApprover1 = event;
      this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = false;
      this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = true;

      if (this.secondApproverComboBox) {
        // this.secondApproverComboBox.isFocused = true;
        this.secondApproverComboBox.toggle(true);
      }
    }
    else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'approved' && idx == 1) {
      this.approval1Approver1ApprovesApprover1 = event;
      this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = false;
      this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;

      if (this.firstApproverRejectComboBox) {
        // this.firstApproverRejectComboBox.isFocused = true;
        this.firstApproverRejectComboBox.toggle(true);
      }
    }
    else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'rejected' && idx == 1) {
      this.approval1Approver1RejectsApprover1 = event;
      this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = false;
      this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false;

      if (this.secondApproverComboBox) {
        // this.secondApproverComboBox.isFocused = true;
        this.secondApproverComboBox.toggle(true);
      }
    }

    //------------------------------- 2nd approval ----------------------------------------

    if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'approved' && idx == 2) {
      this.approval2ApprovesApprover2 = event;
      this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = true;
      this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;

      if (this.secondApproverRejectComboBox) {
        // this.secondApproverRejectComboBox.isFocused = true;
        this.secondApproverRejectComboBox.toggle(true);
      }
    }
    else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'approved' && idx == 2) {
      this.approval2ApprovesApprover2 = event;
      this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = false;
      this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = true;


      if (this.secondApproverRejectComboBox) {
        // this.secondApproverRejectComboBox.isFocused = true;
        this.secondApproverRejectComboBox.toggle(true);
      }
    }
    else if (event && event.toLowerCase() == 'email' && key.toLowerCase() == 'rejected' && idx == 2) {
      this.approval2RejectsApprover1 = event;
      this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = true;
      this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false;
    }
    else if (event && event.toLowerCase() == 'cc' && key.toLowerCase() == 'rejected' && idx == 2) {
      this.approval2RejectsApprover1 = event;
      this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = false;
      this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = true;
    }
    else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'approved' && idx == 2) {
      this.approval2ApprovesApprover2 = event;
      this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = false;
      this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;


      if (this.secondApproverRejectComboBox) {
        // this.secondApproverRejectComboBox.isFocused = true;
        this.secondApproverRejectComboBox.toggle(true);
      }
    }
    else if ((!event || event.toLowerCase() == 'none') && key.toLowerCase() == 'rejected' && idx == 2) {
      this.approval2RejectsApprover1 = event;
      this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = false;
      this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false;
    }
  }

  async siteNameSelected(sites: SiteLisitng[], FromEdit: boolean = false) {
    this.selectedSiteIds = [];
    sites.forEach(element => {
      this.selectedSiteIds.push(element.id);
    });

    if (!FromEdit) {
      this.vendors = this.selectedVendors = [];

      this.persons = this.personsFiltered1 = this.personsFiltered2 = [];
      this.selectedPerson1Item = this.selectedPerson2Item = null;
    }

    if (this.selectedSiteIds && this.selectedSiteIds.length > 0) {
      try {
        this.vendors = await firstValueFrom(this._vendorsService.getVendorsBySiteId(this.selectedSiteIds));
      } catch {
        this.vendors = [];
      }
      if (!FromEdit) {
        try {
          const persons = await firstValueFrom(this._usersService.getPersonsIsUsers(this.selectedSiteIds));
          this.persons = this.personsFiltered1 = this.personsFiltered2 = persons;
        } catch {
          this.persons = this.personsFiltered1 = this.personsFiltered2 = [];
        }
      }
    }
  }


  OpenStatusComboBox() {
    // this.statusComboBox.isFocused = true;
    this.statusComboBox.toggle(true);
  }


  SelectedStatus(event: any) {
    if (!event) {
      this.isEnable = undefined;
    }
    else {
      this.isEnable = event.value;
    }
  }

  onStatusRadioChange(enable: boolean) {
    this.isEnable = enable;
    this.statusValue = enable ? { name: 'Enable', value: true } : { name: 'Disable', value: false };
  }

  isItemSelected(id: any) {
    // return this.selectedSiteNames.some(item => item.id === id);
    return this.selectedSiteIds.some(item => item === id);
  }
  // nextStep() {
  //     this._currentStep += 1;
  // }
  // previousStep() {
  //     if (this._currentStep > 0) {
  //         this._currentStep -= 1;
  //     }
  // }
  async _notificationOptionChange(value: any) {
    this._currentNotificationOption = value;
    if (this._currentNotificationOption === 'Yes') {
      this._notificationOptionValue = 'Yes';
      this.creatorEmail = undefined;
      this.approvesCreator = undefined;
      this.rejectsCreator = undefined;

      await this.delay(300)

      if (this.creatorPendingNotification) {
        // this.creatorPendingNotification.isFocused = true;
        this.creatorPendingNotification.toggle(true);
      }
    }
    if (this._currentNotificationOption === 'No') {
      this._notificationOptionValue = 'No';
      this.creator_Email = false;
      this.approverApprovesCreator_Email = false;
      this.approverApprovesCreator_Cc = false;
      this.approverRejectsCreator_Email = false;
      this.approverRejectsCreator_Cc = false;
      this.creatorEmail = undefined;
      this.approvesCreator = undefined;
      this.rejectsCreator = undefined;
    }
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  async _approverNumberChange(value: any) {
    this._currentApproverNumber = value;
    if (this._currentApproverNumber === 1) {
      this._approverNumberValue = 1;
    }
    else if (this._currentApproverNumber === 2) {
      this._approverNumberValue = 2;
    }
    else {
      this._approverNumberValue = undefined;
    }


    await this.delay(500);

    if (this.firstApproverComboBox) {
      // this.firstApproverComboBox.isFocused = true;
      this.firstApproverComboBox.toggle(true);
    }
  }

  public isItemDisabled(item: { dataItem: any, id: any, text: string, value: string }): boolean {
    //return item.disabled === true;
    if (this.loggedInSite > 0 && this.loggedInSite !== SitesEnum.AllSites)
      return this.loggedInSite != item['dataItem'].id;
    else
      return false;
  }
  private async _initPage(cycleChanged: boolean = false) {
    var accountSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));
    if (accountSites && accountSites.length > 0)
      this.loggedInSite = accountSites[0].siteId;

    const result = await firstValueFrom(this._multiSitesService.getAllSites());
    this.sites = (result as any) || [];
    if (accountSites && accountSites.length > 0 && accountSites[0].siteId > 0 && accountSites[0].siteId !== SitesEnum.AllSites) {
      this.sites = this.sites.filter(x => x.id == accountSites[0].siteId || x.id == SitesEnum.AllSites);
    }

    //Push First Site Untill handle multi sites
    this.selectedSites = [];
    // this.selectedSites.push(this.sites[0]);
    // this.selectedSiteIds.push(this.sites[0].id);
    this.vendors = [];

    if (this.inputCycleCode) {
      this.inputCycleCode.nativeElement.focus();
    }

    if (this.isEditMode) {
      this.stockPurchaseOrderApprovalResponse = this._model;
      this._steps.forEach(step => step.disabled = false);
    }
    else {
      this._selectedStockPurchaseOrderApproval = null;
    }


    //await (await this._usersService.getPersons()).subscribe((persons: any) => {
    //   await (await this._usersService.getPersonsIsUsers()).subscribe((persons: any) => {
    //     this.persons = this.personsFiltered1 = this.personsFiltered2 = persons;
    // });

    if (this.isEditMode && this.stockPurchaseOrderApprovalResponse) {
      this.approvalCycleCode = this.stockPurchaseOrderApprovalResponse.code;

      this.selectedSites = [];
      this.stockPurchaseOrderApprovalResponse.poApprovalSites?.forEach(element => {
        const targetSiteId = element.siteId ?? element.site?.id;
        if (targetSiteId != null) {
          var selectedSite = this.sites.find(f => f.id == targetSiteId);
          if (selectedSite)
            this.selectedSites.push(selectedSite);
        }
        else {
          var selectedSite = this.sites.find(f => f.id == 0 || f.id == SitesEnum.AllSites);
          if (selectedSite)
            this.selectedSites.push(selectedSite);
        }
      });

      await this.siteNameSelected(this.selectedSites, true);

      try {
        const persons = await firstValueFrom(this._usersService.getPersonsIsUsers(this.selectedSiteIds));
        this.persons = this.personsFiltered1 = this.personsFiltered2 = persons;
      } catch {
        this.persons = this.personsFiltered1 = this.personsFiltered2 = [];
      }

      if (this.stockPurchaseOrderApprovalResponse.enableCycle == true) {
        var enableStatus: any = {
          name: 'Enable',
          value: true
        };

        this.statusValue = enableStatus;
        this.isEnable = true;
      }
      else if (this.stockPurchaseOrderApprovalResponse.enableCycle == false) {
        var disableStatus: any = {
          name: 'Disable',
          value: false
        };

        this.statusValue = disableStatus;
        this.isEnable = false;
      }

      this.selectedVendors = [];

      var poVendorApprovals = this.stockPurchaseOrderApprovalResponse.poApprovalSites?.map(x => x.poVendorApprovals) || [];

      poVendorApprovals.forEach(element => {
        element?.forEach(poVendorApproval => {
          if (poVendorApproval?.vendor && !this.selectedVendors.find(x => x.code == poVendorApproval.vendor.code))
            this.selectedVendors.push(poVendorApproval.vendor);
        });
      });

        if (this.stockPurchaseOrderApprovalResponse?.poApprovalDetails && this.stockPurchaseOrderApprovalResponse.poApprovalDetails.length > 0) {
          if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].creator_Email == true ||
            this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverRejectsCreator_Email == true ||
            this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverRejectsCreator_Cc == true ||
            this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverApprovesCreator_Email == true ||
            this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverApprovesCreator_Cc == true) {
            this._form.controls.notificationOption.setValue('Yes');
            this._notificationOptionChange('Yes');

            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].creator_Email == true) {
              this.PendingRequestNotification('Email');
            }
            else {
              this.PendingRequestNotification('None')
            }

            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverApprovesCreator_Email == true) {
              this.ApprovedRequestNotification('Email');
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverApprovesCreator_Cc == true) {
              this.ApprovedRequestNotification('CC');
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverApprovesCreator_Email == false &&
              this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverApprovesCreator_Cc == false) {
              this.ApprovedRequestNotification('None');
            }

            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverRejectsCreator_Email == true) {
              this.RejectedRequestNotification('Email');
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverRejectsCreator_Cc == true) {
              this.RejectedRequestNotification('CC');
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverRejectsCreator_Email == false &&
              this.stockPurchaseOrderApprovalResponse.poApprovalDetails[0].approverRejectsCreator_Cc == false) {
              this.RejectedRequestNotification('None');
            }

          }
          else {
            this._form.controls.notificationOption.setValue('No');
            this._notificationOptionChange('No');
          }
        }

        if (this.stockPurchaseOrderApprovalResponse && this.stockPurchaseOrderApprovalResponse.poApprovalDetails && this.stockPurchaseOrderApprovalResponse.poApprovalDetails.length) {
          this._currentApproverNumber = this.stockPurchaseOrderApprovalResponse.poApprovalDetails.length;
          this._approverNumberChange(this._currentApproverNumber);
        }

        for (var i = 0; i < this.stockPurchaseOrderApprovalResponse.poApprovalDetails.length; i++) {
          if (i == 0) {
            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].isCreatorManager) {
              var creatorManager = {
                field: 'isCreatorManager1',
                displayName: 'Creator\'s Manager',
              };
              this.firstApprover = creatorManager;
              this.PickApprover(creatorManager);

            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].isPerson) {

              var person =
              {
                field: 'isPerson1',
                displayName: 'Choose a person',
              };
              this.firstApprover = person;
              this.PickApprover(person);

              var selectedPerson = this.personsFiltered1.find(f => f.id == this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].personId);
              this.selectedPerson1Item = selectedPerson;
              this.onPersonsGridSelectionChange(this.selectedPerson1Item, 1);
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].isAdminSecurityLevel) {
              var adminSecurityLevel = {
                field: 'isAdminSecurityLevel1',
                displayName: 'Any Admin Level Person',
              };

              this.firstApprover = adminSecurityLevel;
              this.PickApprover(adminSecurityLevel);
            }

            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Email) {
              this.ApproverConfiguration('Email', 'approved', 1);
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Cc) {
              this.ApproverConfiguration('CC', 'approved', 1);
            }
            else if (!this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Email && !this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Cc) {
              this.ApproverConfiguration('None', 'approved', 1);
            }

            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Email) {
              this.ApproverConfiguration('Email', 'rejected', 1)
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Cc) {
              this.ApproverConfiguration('CC', 'rejected', 1)
            }
            else if (!this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Email && !this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Cc) {
              this.ApproverConfiguration('None', 'rejected', 1)
            }

          }
          else if (i == 1) {
            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].isCreatorManager) {
              var creatorManager = {
                field: 'isCreatorManager2',
                displayName: 'Creator\'s Manager',
              };
              this.sndApprover = creatorManager;
              this.PickApprover(creatorManager);

            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].isPerson) {

              var person =
              {
                field: 'isPerson2',
                displayName: 'Choose a person',
              };
              this.sndApprover = person;
              this.PickApprover(person);


              var selectedPerson = this.personsFiltered2.find(f => f.id == this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].personId);
              this.selectedPerson2Item = selectedPerson;
              this.onPersonsGridSelectionChange(this.selectedPerson2Item, 2);

            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].isAdminSecurityLevel) {
              var adminSecurityLevel = {
                field: 'isAdminSecurityLevel2',
                displayName: 'Any Admin Level Person',
              };

              this.sndApprover = adminSecurityLevel;
              this.PickApprover(adminSecurityLevel);
            }

            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Email) {
              this.ApproverConfiguration('Email', 'approved', 2);
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Cc) {
              this.ApproverConfiguration('CC', 'approved', 2);
            }
            else if (!this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Email && !this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverApprovesApprover_Cc) {
              this.ApproverConfiguration('None', 'approved', 2);
            }

            if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Email) {
              this.ApproverConfiguration('Email', 'rejected', 2)
            }
            else if (this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Cc) {
              this.ApproverConfiguration('CC', 'rejected', 2)
            }
            else if (!this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Email && !this.stockPurchaseOrderApprovalResponse.poApprovalDetails[i].approverRejectsApprover_Cc) {
              this.ApproverConfiguration('None', 'rejected', 2)
            }
          }
        }
      }
    // this._initForm();
  }


  OpenSiteComboBox() {
    // this.kendoMultiselect.isFocused = true;
    this.kendoMultiselect.toggle(true);
  }

  public onCycleSelectionChange(event: any) {
    if (this._selectedCycle.value) {
      this.selectedCycleId = event ? event.id : null;
      this._initPage(true);
      this._currentForm = this.getFormByStep(this._currentStep);
      this.validateSteps();
    }
    else {
      this._currentForm = this.getFormByStep(this._currentStep);
      this.validateSteps();
    }
  }

  public enableApproval1Changed(event: any) {
    if (!event.target.checked) {
      this._form.controls['enableApproval2'].disable();
      this._form.controls['enableApproval2'].setValue(false);
    }
    else {
      this._form.controls['enableApproval2'].enable();
    }
  }

  public addNewCycle() {
    this.showApprovalCycleTextField = true;
    this.selectedCycleId = null;
    this._initPage(true);
  }

  private enableCycle() {
    return this._selectedStockPurchaseOrderApproval ?
      {
        name: this._selectedStockPurchaseOrderApproval.enableCycle ?
          "Enable" : "Disable",
        value: this._selectedStockPurchaseOrderApproval.enableCycle
      } :
      { name: "Disable", value: false };
  }

  private approver(approveridx: number) {
    let approver;
    if (approveridx == 1) {
      approver = this._selectedStockPurchaseOrderApproval ?
        (
          this._selectedStockPurchaseOrderApproval.isCreatorManager1 ?
            {
              field: 'isCreatorManager1',
              displayName: 'Creator\'s Manager'
            }
            : this._selectedStockPurchaseOrderApproval.isPerson1 ?
              {
                field: 'isPerson1',
                displayName: 'Choose a person'
              }
              : this._selectedStockPurchaseOrderApproval.isAdminSecurityLevel1 ?
                {
                  field: 'isAdminSecurityLevel1',
                  displayName: 'Any Admin Level Person'
                }
                :
                { field: '', displayName: '' }

        ) :
        { field: '', displayName: '' };
    }
    else {
      approver = this._selectedStockPurchaseOrderApproval ?
        (

          this._selectedStockPurchaseOrderApproval.isCreatorManager2 ?
            {
              field: 'isCreatorManager2',
              displayName: 'Creator\'s Manager'
            }
            : this._selectedStockPurchaseOrderApproval.isPerson2 ?
              {
                field: 'isPerson2',
                displayName: 'Choose a person'
              }
              : this._selectedStockPurchaseOrderApproval.isAdminSecurityLevel2 ?
                {
                  field: 'isAdminSecurityLevel2',
                  displayName: 'Any Admin Level Person'
                }
                :
                { field: '', displayName: '' }

        ) :
        { field: '', displayName: '' };

    }
    return approver;
  }

  private notification(field: string) {
    let res = '',
      email = (field + '_Email') as keyof StockPurchaseOrderApprovals,
      cc = (field + '_CC') as keyof StockPurchaseOrderApprovals;
    if (this._selectedStockPurchaseOrderApproval) {
      res = this._selectedStockPurchaseOrderApproval[email] ? 'Email' :
        this._selectedStockPurchaseOrderApproval[cc] ? 'CC' : 'None';
    }
    return res;
  }

  private _initForm() {
    this._form = this.formBuilder.group({
      _selectedCycle: new FormControl(null, Validators.required),
      notificationOption: [],
      approverNumber: [],
      firstApprover: [this.approver(1)],

      approval1Approver1ApprovesApprover1: [this.notification('approval1Approver1ApprovesApprover1')],
      approval1Approver1RejectsApprover1: [this.notification('approval1Approver1RejectsApprover1')],

      approval2ApprovesApprover2: [this.notification('approval2ApprovesApprover2')],
      approval2RejectsApprover1: [this.notification('approval2RejectsApprover1')],

      approval1ApproverRejectsCreator: [this.notification('approval1ApproverRejectsCreator')],
      approval1AdminSecurityLevelPerson: [this.notification('approval1AdminSecurityLevelPerson')],
      approval1Approver1ApprovesCreator: [this.notification('approval1Approver1ApprovesCreator')],
      approval2Manager: [this.notification('approval2Manager')],
      approval2AdminSecurityLevel: [this.notification('approval2AdminSecurityLevel')],
      approval2ApprovesCreator: [this.notification('approval2ApprovesCreator')],
      approval2ApprovesApprover1: [this.notification('approval2ApprovesApprover1')],
      approval2RejectsApprover2: [this.notification('approval2RejectsApprover2')],
      approval2RejectsCreator: [this.notification('approval2RejectsCreator')],
      approval1Manager: [this.notification('approval1Manager')],

      sndApprover: [this.approver(2)],
      code: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.code : null],
      enableCycle: [this.enableCycle()],
      enableApproval1: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.enableApproval1 : false],
      approval1Creator_Email: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.approval1Creator_Email : false],
      approval1PersonId: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.approval1PersonId : null],
      approval1PersonId_Email: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.approval1PersonId_Email : false],
      approval1PersonId_Cc: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.approval1PersonId_Cc : false],
      enableApproval2: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.enableApproval2 : false],
      approval2PersonId: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.approval2PersonId : null],
      approval2PersonId_Email: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.approval2PersonId_Email : false],
      approval2PersonId_Cc: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.approval2PersonId_Cc : false],
      siteNames: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.siteNames : ''],
      selectedCustSupp: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.selectedCustSupp : ''],
      createdUnderSite: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.createdUnderSite : null],
      status: [this._selectedStockPurchaseOrderApproval ? this._selectedStockPurchaseOrderApproval.status : 'active'],
    });

    if (this._selectedStockPurchaseOrderApproval) {
      for (const prop in this._selectedStockPurchaseOrderApproval) {
        this.emailCcObjsList[prop + 'IsChecked'] = this._selectedStockPurchaseOrderApproval[prop as keyof StockPurchaseOrderApprovals] || false;
      }
    }
    else {
      for (const prop in this.emailCcObjsList) {
        this.emailCcObjsList[prop] = false;
      }
    }

    this._selectedCycle.setValue(this._selectedStockPurchaseOrderApproval || null);

    if (!this._form.controls['enableApproval1'].value)
      this._form.controls['enableApproval2'].disable();
  }

  private fillApiObjWithNotificationsField(field: string, model: any): any {
    if (this._form.controls[field].value === 'Email') {
      model[field + '_Email'] = true;
      model[field + '_CC'] = false;
    }
    else if (this._form.controls[field].value === 'CC') {
      model[field + '_CC'] = true;
      model[field + '_Email'] = false;
    }
    else {
      model[field + '_CC'] = false;
      model[field + '_Email'] = false;
    }
    return model;
  }


  ValidateEmail(idx: number) {
    if (idx == 1) {
      if (this.approverApprovesCreator_Cc == true && this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked == true) {
        this.approverApprovesCreator_Cc = false;
        this.approverApprovesCreator_Email = true;
        this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = true;
        this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;
      }
      if (this.approverApprovesCreator_Email == false &&
        this.approverApprovesCreator_Cc == false &&
        this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked == true) {
        this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked = true;
        this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked = false;
      }
      if (this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked == false &&
        this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked == false &&
        this.approverApprovesCreator_Cc == true) {
        this.approverApprovesCreator_Email = true;
        this.approverApprovesCreator_Cc = false;
      }

      //--------------------------------------------- reject ---------------------------------------------

      if (this.approverRejectsCreator_Cc == true && this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked == true) {
        this.approverRejectsCreator_Email = true;
        this.approverRejectsCreator_Cc = false;
        this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = true;
        this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false;
      }

      if (this.approverRejectsCreator_Email == false &&
        this.approverRejectsCreator_Cc == false &&
        this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked == true) {
        this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked = true;
        this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked = false
      }

      if (this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked == false &&
        this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked == false &&
        this.approverRejectsCreator_Cc == true) {
        this.approverRejectsCreator_Email = true;
        this.approverRejectsCreator_Cc = false;
      }
    }
    else if (idx == 2) {
      if (this.approverApprovesCreator_Cc == true && this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked == true) {
        this.approverApprovesCreator_Cc = false;
        this.approverApprovesCreator_Email = true;
        this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = true;
        this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;
      }
      if (this.approverApprovesCreator_Email == false &&
        this.approverApprovesCreator_Cc == false &&
        this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked == true) {
        this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked = true;
        this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked = false;
      }
      if (this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked == false &&
        this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked == false &&
        this.approverApprovesCreator_Cc == true) {
        this.approverApprovesCreator_Email = true;
        this.approverApprovesCreator_Cc = false;
      }

      //--------------------------------------------- reject ---------------------------------------------

      if (this.approverRejectsCreator_Cc == true && this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked == true) {
        this.approverRejectsCreator_Email = true;
        this.approverRejectsCreator_Cc = false;
        this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = true;
        this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false;
      }

      if (this.approverRejectsCreator_Email == false &&
        this.approverRejectsCreator_Cc == false &&
        this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked == true) {
        this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked = true;
        this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked = false
      }

      if (this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked == false &&
        this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked == false &&
        this.approverRejectsCreator_Cc == true) {
        this.approverRejectsCreator_Email = true;
        this.approverRejectsCreator_Cc = false;
      }
    }

  }



  private submit = () => {
    if (!this.approvalCycleCode || !this.selectedSiteIds || this.selectedSiteIds.length == 0 || this.isEnable == undefined) {
      return;
    }
    if (this.isEnable !== false) {
      if (!this._approverNumberValue || this._approverNumberValue == 0) {
        return
      }
      else if (this._approverNumberValue > 0) {
        if (this._approverNumberValue == 1 &&
          this.emailCcObjsList.isCreatorManager1IsChecked == false &&
          (this.emailCcObjsList.isPerson1IsChecked == false || (this.emailCcObjsList.isPerson1IsChecked == true && this.emailCcObjsList.person1Id == 0)) &&
          this.emailCcObjsList.isAdminSecurityLevel1IsChecked == false) {
          return;
        }
        else if (this._approverNumberValue == 2 && (
          (this.emailCcObjsList.isCreatorManager1IsChecked == false &&
            this.emailCcObjsList.isPerson1IsChecked == false &&
            this.emailCcObjsList.isAdminSecurityLevel1IsChecked == false) ||
          (
            this.emailCcObjsList.isCreatorManager2IsChecked == false &&
            (this.emailCcObjsList.isPerson2IsChecked == false || (this.emailCcObjsList.isPerson2IsChecked == true && this.emailCcObjsList.person2Id == 0)) &&
            this.emailCcObjsList.isAdminSecurityLevel2IsChecked == false)
        )) {
          return;
        }
      }
    }


    this.poApprovalCycleRequest = new PoApprovalCycleRequestModel();
    this.poApprovalCycleRequest.code = this.approvalCycleCode;
    this.poApprovalCycleRequest.sitesId = this.selectedSiteIds;
    this.poApprovalCycleRequest.isEnable = this.isEnable;
    this.poApprovalCycleRequest.vendorsId = this.selectedVendors.map(x => x.id);

    var poApprovalDetailsRequests: ApprovalDetailsRequestModel[] = [];

    this.ValidateEmail(1);

    if (this._approverNumberValue) {
      for (var i = 0; i < this._approverNumberValue; i++) {
        if (i == 0) {
          var poApprovalDetailsRequest = new ApprovalDetailsRequestModel();
          poApprovalDetailsRequest.creator_Email = this.creator_Email;


          poApprovalDetailsRequest.approverApprovesCreator_Email = this.approverApprovesCreator_Email;
          poApprovalDetailsRequest.approverApprovesCreator_Cc = this.approverApprovesCreator_Cc;
          poApprovalDetailsRequest.approverRejectsCreator_Email = this.approverRejectsCreator_Email;
          poApprovalDetailsRequest.approverRejectsCreator_Cc = this.approverRejectsCreator_Cc;

          poApprovalDetailsRequest.isCreatorManager = this.emailCcObjsList.isCreatorManager1IsChecked;
          poApprovalDetailsRequest.manager_Email = this.emailCcObjsList.approval1Manager_EmailIsCheckedIsChecked;
          poApprovalDetailsRequest.manager_Cc = this.emailCcObjsList.approval1Manager_CcIsChecked;
          poApprovalDetailsRequest.isPerson = this.emailCcObjsList.isPerson1IsChecked;
          if (this.emailCcObjsList.person1Id > 0) {
            poApprovalDetailsRequest.personId = this.emailCcObjsList.person1Id;
          }
          poApprovalDetailsRequest.personId_Email = this.emailCcObjsList.approval1PersonId_EmailIsChecked;
          poApprovalDetailsRequest.personId_Cc = this.emailCcObjsList.approval1PersonId_CcIsChecked;
          poApprovalDetailsRequest.isAdminSecurityLevel = this.emailCcObjsList.isAdminSecurityLevel1IsChecked;
          poApprovalDetailsRequest.adminSecurityLevelPerson_Email = this.emailCcObjsList.approval1AdminSecurityLevelPerson_EmailIsChecked;
          poApprovalDetailsRequest.adminSecurityLevelPerson_Cc = this.emailCcObjsList.approval1AdminSecurityLevelPerson_CcIsChecked;
          poApprovalDetailsRequest.approverApprovesApprover_Email = this.emailCcObjsList.approval1Approver1ApprovesApprover1_EmailIsChecked;
          poApprovalDetailsRequest.approverApprovesApprover_Cc = this.emailCcObjsList.approval1Approver1ApprovesApprover1_CcIsChecked;
          poApprovalDetailsRequest.approverRejectsApprover_Email = this.emailCcObjsList.approval1Approver1RejectsApprover1_EmailIsChecked;
          poApprovalDetailsRequest.approverRejectsApprover_Cc = this.emailCcObjsList.approval1Approver1RejectsApprover1_CcIsChecked;
          poApprovalDetailsRequest.order = 1;

          poApprovalDetailsRequests.push(poApprovalDetailsRequest);
        }
        else {
          this.ValidateEmail(2);
          var poApprovalDetailsRequest = new ApprovalDetailsRequestModel();
          poApprovalDetailsRequest.creator_Email = this.creator_Email;


          poApprovalDetailsRequest.approverApprovesCreator_Email = this.approverApprovesCreator_Email;
          poApprovalDetailsRequest.approverApprovesCreator_Cc = this.approverApprovesCreator_Cc;
          poApprovalDetailsRequest.approverRejectsCreator_Email = this.approverRejectsCreator_Email;
          poApprovalDetailsRequest.approverRejectsCreator_Cc = this.approverRejectsCreator_Cc;

          poApprovalDetailsRequest.isCreatorManager = this.emailCcObjsList.isCreatorManager2IsChecked;
          poApprovalDetailsRequest.manager_Email = this.emailCcObjsList.approval2Manager_EmailIsChecked;
          poApprovalDetailsRequest.manager_Cc = this.emailCcObjsList.approval2Manager_CcIsChecked;
          poApprovalDetailsRequest.isPerson = this.emailCcObjsList.isPerson2IsChecked;
          if (this.emailCcObjsList.person2Id > 0) {
            poApprovalDetailsRequest.personId = this.emailCcObjsList.person2Id;
          }
          poApprovalDetailsRequest.personId_Email = this.emailCcObjsList.approval2PersonId_EmailIsChecked;
          poApprovalDetailsRequest.personId_Cc = this.emailCcObjsList.approval2PersonId_CcIsChecked;
          poApprovalDetailsRequest.isAdminSecurityLevel = this.emailCcObjsList.isAdminSecurityLevel2IsChecked;
          poApprovalDetailsRequest.adminSecurityLevelPerson_Email = this.emailCcObjsList.approval2AdminSecurityLevel_EmailIsChecked;
          poApprovalDetailsRequest.adminSecurityLevelPerson_Cc = this.emailCcObjsList.approval2AdminSecurityLevel_CcIsChecked;
          poApprovalDetailsRequest.approverApprovesApprover_Email = this.emailCcObjsList.approval2ApprovesApprover2_EmailIsChecked;
          poApprovalDetailsRequest.approverApprovesApprover_Cc = this.emailCcObjsList.approval2ApprovesApprover2_CcIsChecked;
          poApprovalDetailsRequest.approverRejectsApprover_Email = this.emailCcObjsList.approval2RejectsApprover2_EmailIsChecked;
          poApprovalDetailsRequest.approverRejectsApprover_Cc = this.emailCcObjsList.approval2RejectsApprover2_CcIsChecked;
          poApprovalDetailsRequest.order = 2;

          poApprovalDetailsRequests.push(poApprovalDetailsRequest);
        }
      }
    }


    this.poApprovalCycleRequest.poApprovalDetails = poApprovalDetailsRequests;
    if (this.stockPurchaseOrderApprovalResponse) {
      this._poApprovalsService
        .updateStockPurchaseOrderApproval(this.poApprovalCycleRequest, this.stockPurchaseOrderApprovalResponse.id)

        .subscribe((response: any) => {

          this._closeForm();

          this._layoutComponent.openPopup({
            title: 'Alert',
            message: 'Approval Cycle Updated Successfully.',
            withoutConfirm: true
          });
        }
          // , _ => {
          //     this._layoutComponent.openPopup({
          //         title: 'Alert',
          //         message: 'The purchase order approval code already exist or the vendor is already assigned to another purchase order approval.',
          //         withoutConfirm: true
          //     });
          // }

        );
    }
    else {
      this._poApprovalsService
        .createStockPurchaseOrderApproval(this.poApprovalCycleRequest)

        .subscribe((response: any) => {


          this._closeForm();

          this._layoutComponent.openPopup({
            title: 'Alert',
            message: 'Approval Cycle Saved Successfully.',
            withoutConfirm: true
          });
          this._initPage(true);
        }
          // , _ => {
          //     this._layoutComponent.openPopup({
          //         title: 'Alert',
          //         message: 'The purchase order approval code already exist or the vendor is already assigned to another purchase order approval.',
          //         withoutConfirm: true
          //     });
          // }

        );
    }
  }
}